import { Card, CommanderData, Deck, Query } from '@deckplan.io/common';
import { CardService } from '../../cards/card.service';
import { MatDialog } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { BlockData, BrawlData, FocusedData } from '@deckplan.io/common/decks/deck';
import { CardPickerComponent } from '../../cards/card-picker/card-picker.component';
import { filter, map } from 'rxjs/operators';

export interface AddFocusEvent {
    card: Card;
    specialData: CommanderData | BlockData | BrawlData | FocusedData;
}

export abstract class Format {

    constructor(protected deck: Deck, protected cardsService: CardService, protected dialog: MatDialog, protected isReadOnly: boolean) {}

    // Interface to retrieve the focused cards for a given format
    public getFocused(): Observable<Card | Card[]> {
        if (!this.deck.specialData) {
            return of(null);
        }
        const focusedData = this.deck.specialData as FocusedData;
        const focusedCard = this.deck.cards.find(card => card.id === focusedData.focusedId);

        if (focusedData && !focusedCard && focusedData.focusedId) {
            return this.cardsService.getCard(focusedData.focusedId);
        } else {
            return of(focusedCard);
        }
    }

    // Interface to prompt the user to pick a focused card
    public addFocused(): Observable<AddFocusEvent> {
        if (this.isReadOnly) {
            return;
        }

        const dialogRef = this.dialog.open(CardPickerComponent, {
            width: '100vw',
            minWidth: '100vw',
            height: '100vh',
            minHeight: '100vh',
            disableClose: false,
            data: {
                showOwnedCardsSelector: true,
                deck: this.deck,
                override: true
            }
        });
        return dialogRef.afterClosed().pipe(filter(card => card), map(card => ({card, specialData: {focusedId: card.id}})));
    }

    // Interface to create a query to be used to filter cards
    public abstract addCardsQuery(): Query;

    // Interface to create a query to be used to filter the cards of the deck
    public deckCardsQuery(): Query {
        return undefined;
    }

    // Interface to validate that a deck can be a given format
    // returns a list of cards that need to be removed to match that format
    public abstract validate(): Card[];

    // Interface to get the text of the "Select focus" overlay
    public selectFocusText(): string {
        return 'Select focused card';
    }
}
